<form *ngIf="form" [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="save()" RestrictFocus>

  <div class="ui-grid ui-grid-responsive ui-fluid" >
    <div class="ui-grid-row">
      <div class="ui-grid-col-4">
        <label>{{ 'customers.new_password' | translate }}</label>
      </div>
      <div class="ui-grid-col-8">
        <input formControlName="password" type="text" pInputText />
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
      <br />
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check" label="{{ ('customers.auth_reset' | translate) }} "></button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/admin/customersAuthForm.html